import { useQuery } from '@tanstack/react-query';
import useAxios from '../../../../app/hooks/useAxios';
import { useAuthContext } from '../../contexts/AuthContext';

interface IAuthOktaUserFactorCatalogItem {
	status?: string;
	factorType: string;
	provider: string;
	_embedded?: {
		phones?: Array<{ id: string; profile: { phoneNumber: string }; status: string }>;
		emails?: Array<{ id: string; profile: { email: string }; status: string }>;
	};
}

const useAuthOktaUserFactorsCatalog = () => {
	const { get } = useAxios();
	const auth = useAuthContext();

	return useQuery(
		['authOktaUserFactorsCatalog'],
		async () => {
			const response = await get(`/users/me/factors/catalog`);
			return response.data as IAuthOktaUserFactorCatalogItem[];
		},
		{
			enabled: auth.authContext === 'investor',
		},
	);
};

export default useAuthOktaUserFactorsCatalog;
